import request from '@/api/config/request'

const prex = "api/ranfs";

export function listRanfs(eco_codigo, query = {}) {
    return request({
        url: `${prex}/list/${eco_codigo}`,
        method: 'get',
        params: query
    })
}

export function solicitarRanfs(data) {
    return request({
        url: `${prex}/solicitar`,
        method: 'post',
        data
    })
}

export function cancelarRanfs(data) {
    return request({
        url: `${prex}/cancelar`,
        method: 'post',
        data
    })
}

export function downloadRanfs(ranfs) {
    return request({
        url: `relatorio/ranfs/download/${ranfs}`,
        method: 'get'
    })
}
